export default {"src":"/_next/static/media/fire-smart-balanced.5bb7ce18.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};